import { useNavigate } from "@tanstack/react-router";
import { AlertTriangle } from "lucide-react";
import {
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export function InvitationInvalidCard() {
  const navigate = useNavigate();

  return (
    <>
      <CardHeader className="items-center text-center">
        <div className="rounded-full bg-amber-100 p-3 mb-2">
          <AlertTriangle className="h-6 w-6 text-amber-600" />
        </div>
        <CardTitle className="text-xl">Invitation not available</CardTitle>
        <CardDescription>
          This invitation link is invalid or no longer active. Ask your
          organization to send a new one.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Button
          variant="outline"
          className="w-full"
          onClick={() => navigate({ to: "/" })}
        >
          Go to Saile
        </Button>
      </CardContent>
    </>
  );
}
